import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ConstantsService } from 'src/app/services/constants.service';

const base_url = environment.base_url;


@Injectable({
  providedIn: 'root'
})
export class ActividadesService {

  private url = ConstantsService.ACTIVIDADES_URL;
  private urlArchivos = ConstantsService.ACTIVIDADES_FILE_URL;
  constructor(private http: HttpClient) { }

  create(formData: any): Observable<any> {
    return this.http.post(`${this.url}`, formData).pipe(map(data => {
      return data;
    }));
  }

  list(query: string = ''): Observable<any> {
    return this.http.get(`${this.url}${query}`).pipe(map(
      data => { return data; }
    ));
  }

  update(formData: any): Observable<any> {
    let { idSprActividad } = formData;
    return this.http.patch(`${this.url}${idSprActividad}`, formData).pipe(map(
      data => {
        return data;
      }
    ));
  }

  delete(dataDelete: any): Observable<any> {
    let editaEstado = {
      ...dataDelete,
      delLog: "S"
    }
    return this.http.patch(`${this.url}${dataDelete.idSprActividad}`, editaEstado)
  }

  statusChange(data: any): Observable<any> {
    let editaEstadoActividad = {
      ...data,
      estado: "2"
    }
    return this.http.patch(`${this.url}${data.idSprActividad}`, editaEstadoActividad)
  }


  postArchivo(formData: any, id: number): Observable<any> {
    return this.http.post(`${this.urlArchivos}/` + id, formData).pipe(map(data => {
      return data;
    }));
  }

  download(name: string): Observable<any> {
    return this.http.get(`${this.urlArchivos}/` + name)
  }

}



